import TimelineVideo from "../../../../timeline/TimelineVideo/TimelineVideo";

const VideoPreview = require('../../../../../assets/img/timeline/modal/2018-Anniversary.jpg');

const AnniversaryContent = () => {
    return (
        <>
            <TimelineVideo videoId="MbtX7kKQPmU" imagePreview={VideoPreview} />
            <h4>
                Breast Cancer Trials celebrates its’ 40th anniversary
            </h4>
        </>
    );
}

export default AnniversaryContent;